import React from "react";
import { Buffer } from "buffer";
import { environment } from "../utils/environment";
import { RedirectController, RedirectControllerDelegate } from "./controller";
import styles from './styles.module.css';
import { Box } from "@mui/material";
import { getUserRolesFromToken, RolesEnum } from "../utils/getUserRolesFromToken";

export default class Redirect extends React.PureComponent implements RedirectControllerDelegate {

  private controller: RedirectController;

  constructor(props: any) {
    super(props);

    this.controller = new RedirectController(this);
  }

  authenticationFailed(): void {
    window.location.href = decodeURIComponent(environment.baseUrl);
  }

  authenticationSuccess(access: string, refresh: string): void {
    const query = window.location.search;
    const params = new URLSearchParams(query);
    const state = decodeURIComponent(params.get("state") || "");

    const decodedState = state && Buffer.from(state, "base64").toString("utf8")

    const jsonState = decodedState ? JSON.parse(decodedState): {url: environment.baseUrl}

    localStorage.setItem("AccessToken", access);
    localStorage.setItem("RefreshToken", refresh);

    // roles
    const roles = getUserRolesFromToken();
    const isAdmin = roles.includes(RolesEnum.ADMIN);
    const isReseller = roles.includes(RolesEnum.RESELLER);

    // URL based on roles
    let initialUrl = jsonState.url || "/tutorials"; // fallback
    if (isAdmin) {
      initialUrl = "/instruments";
    } else if (isReseller) {
      initialUrl = "/reseller/management";
    } else {
      initialUrl = "/instruments";
    }

    window.location.href = decodeURIComponent(initialUrl);
  }
    
  componentDidMount(): void {
    const query = window.location.search;
    const params = new URLSearchParams(query);
    
    const loggedToken = localStorage.getItem("AccessToken");
    const token = params.get("token")!;

    if(token){
      const token = params.get("token")!;
      this.controller.authenticateUser(token);
    } else if (loggedToken) {
      const loggedRefresh = localStorage.getItem("RefreshToken");
      this.authenticationSuccess(loggedToken, loggedRefresh!);
    } else{
      this.authenticationFailed();
    }
  }


  render() {
    return (
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        alignItems="center"
        justifyContent="center"
        height="100vh"
      >
        <div className={ styles.loader } />
      </Box>
    )
  }
}
